module.exports = __webpack_public_path__ + "static/media/Doodle-100.2b63973f.webp";